export const getLocationIdFromStorage = () => {
  return localStorage.getItem('locationId');
};

export default getLocationIdFromStorage;
